import styled from 'styled-components'
import { Link } from 'react-scroll'
import { FaBars } from 'react-icons/fa'

export const Nav = styled.nav `
    background: #fff;
    box-shadow: 0 4px 4px -2px rgba(0,0,0,.2);
    height: 80px;
    display: flex;
    justify-content: space-between;
    z-index: 10;
    padding: 0.75rem 1.5rem;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
`
export const NavLogo = styled(Link)
`
        display: start;
        align-items: left;
        text-decoration: none;
        height: 100%;
        cursor: pointer;
`

export const MobileIcon = styled.div `
    display: none;

    @media screen and (max-width: 768px) {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 60%);
        font-size: 1.8rem;
        cursor: pointer;
    }

`

export const NavLink = styled(Link)
`
    color: #C4242D;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0rem 1.5rem;
    height: 100%;
    cursor: pointer;

    &.active {
        color: #EE5C4D;
        text-decoration: underline;
    }
`

export const Bars = styled(FaBars)
`
    display: none;
    color: #C4242D;

    @media screen and (max-width: 768px) {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 75%);
        font-size: 1.8rem;
        cursor: pointer;
    }
`

export const NavMenu = styled.div `
    display: flex;
    align-items: center;
    margin-right: -12px;
    white-space: nowrap;
    @media screen and (max-width: 768px) {
        display: none;
    }

`

export const NavBtn = styled.nav `
    display: flex;
    align-items: center;
    margin-right: 24px;

    @media screen and (max-width: 768px) {
        display: none;
    }
`

export const NavBtnLink = styled(Link)
`
    border-radius: 4px;
    background: #EE5C4D;
    padding: 10px 22px;
    color: #fff;
    border: none;
    outline: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;

    &:hover {
        transition: all 0.2s ease-in-out;
        background: #C4242D;
        color: #fff;
    }
`